import React from 'react';
import PushNotificationDemo from './PushNotificationDemo';

const Apropos = () => (
  <div className="slider-rigth-container-centerd">
    <h3>
      made with
      <span className="haert" style={{ color: 'red' }}> ♥ </span>
      by m-naim
    </h3>

    <div>
      <span>
        Contacte moi
      </span>
    </div>
  </div>
);


export default Apropos;
